import * as React from 'react';
import { TDirection } from '@cian/frontend-newbuilding-carousel-component';
import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';
import * as styles from './Arrow.css';

interface IArrowProps {
  direction: TDirection;
  disabled: boolean;
  clickHandler?(direction: TDirection): void;
}

export function Arrow({ direction, disabled, clickHandler }: IArrowProps) {
  return (
    <div
      className={clsx(styles['click_area'], direction < 0 && styles['click_area--left'])}
      onClick={() => {
        return clickHandler && !disabled && clickHandler(direction);
      }}
      data-testid="Arrow"
    >
      <div className={clsx(styles['background'], disabled && styles['click_area--disabled'])}>
        <div className={styles['icon_container']}>
          {direction < 0 ? (
            <IconActionChevronLeft16 color={'icon-secondary-default'} />
          ) : (
            <IconActionChevronRight16 color={'icon-secondary-default'} />
          )}
        </div>
      </div>
    </div>
  );
}
